import React from 'react'
import { Container, Grid } from 'semantic-ui-react'
import { useDispatch } from 'react-redux'

import { CalltoactionContainer } from './style'
import { InvertedButton, Helper } from '../../pages/main_page/components/style'

export const Calltoaction = ({ currentAct, drupalHost }) => {
    const dispatch = useDispatch<any>();

    const handleClick = () => dispatch({ type: 'TOGGLE_WIZARD' })

    return <CalltoactionContainer>
        <Container>
            <Grid verticalAlign="middle" textAlign="center">
                <Grid.Row>
                    <Grid.Column width={16}>
                        {currentAct === 'olymp' ? ' Олимпиады для студентов вузов и ссузов: региональные, всероссийские, международные'
                            : currentAct === 'olymp_en' ? "Discover and support talented young people"
                                : "Оценка и мониторинг качества образования"
                        }
                        <br />
                        {currentAct !== 'olymp_en' &&
                            <>
                                <InvertedButton href={`//auth.${drupalHost}/signup`} basic secondary inverted>
                                    Зарегистрироваться
                                </InvertedButton>
                                <Helper onClick={handleClick}><i>Помощник в выборе сервиса</i></Helper>
                            </>
                        }
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </Container>
    </CalltoactionContainer>
}
